/** English content for /ethics — shared by seed and UI fallbacks. */

export const ethicsEn = {
  pageTitle: 'Ethics in publications',
  subtitleLine1: 'Ethical Standards and Malpractice Statement: Advances in Applied ',
  subtitleLine2: 'Engineering Sciences (AdvAES)',
  sections: {
    s1: {
      title: '1. General Principles',
      line1:
        "1.1. This policy outlines the ethical standards expected of all parties involved in the publication process of Advances in Applied Engineering Sciences (AdvAES), including authors, editors, reviewers, and the publisher. These standards are grounded in widely accepted ethical guidelines for scholarly publishing.",
      line2:
        "1.2. As the publisher of AdvAES, [Publisher's Name/University Name - if applicable], is committed to upholding the integrity of the publication process and recognizes its ethical responsibilities in ensuring the publication of high-quality, reliable research.",
      line3: '',
      line4: '',
      line5: '',
      line6: '',
      line7: '',
      line8: '',
      line9: '',
      line10: '',
      line11: '',
      line12: '',
    },
    s2: {
      title: '2. Ethical Standards for Authors',
      line1:
        '2.1. Data Access and Retention: Authors are expected to provide access to their raw research data upon request from the editorial board, if not already included in the article, and retain this data for a reasonable period after publication to allow for verification and reproducibility.',
      line2:
        '2.2. Originality and Plagiarism: Authors must submit original work. Plagiarism in any form is unacceptable. Proper citation and referencing of others\' work are mandatory.',
      line3:
        '2.3. Concurrent Submission: Articles must not be submitted to multiple journals simultaneously. Translation of previously published work into another language is also considered unethical.',
      line4:
        '2.4. Source Acknowledgment: Authors must accurately cite all sources that significantly influenced their research. Information obtained from private sources should not be used.',
      line5:
        '2.5. Authorship: All individuals who made substantial contributions to the research should be listed as co-authors. The submitting author is responsible for ensuring all co-authors have approved the final article.',
      line6:
        '2.6. Conflict of Interest Disclosure: Authors must disclose any potential conflicts of interest that may affect the interpretation of their work. All sources of funding must be acknowledged.',
      line7:
        '2.7. Error Correction: Authors must promptly notify the editorial board of any significant errors or inaccuracies found in their published work and cooperate in correcting them.',
      line8: '',
      line9: '',
      line10: '',
      line11: '',
      line12: '',
    },
    s3: {
      title: '3. Ethical Standards for Editors',
      line1:
        '3.1. Publication Decisions: Editors are responsible for deciding which submitted articles should be published, based on peer review and adherence to ethical standards. Articles with evidence of plagiarism, libel, copyright infringement, or conflicts of interest will not be published.',
      line2:
        "3.2. Fairness and Impartiality: Articles are evaluated based on their scientific merit, regardless of authors' race, gender, nationality, or institutional affiliation.",
      line3:
        '3.3. Confidentiality: Editors will not disclose information about submitted articles to anyone other than the authors, reviewers, and, if necessary, the publisher.',
      line4:
        "3.4. Conflict of Interest: Editors will not use unpublished articles for their own research without authors' consent and will recuse themselves from reviewing articles where a conflict of interest exists.",
      line5:
        '3.5. Handling Unethical Behavior Claims: Editors will investigate all claims of unethical behavior promptly and take appropriate action, including retraction, correction, or other necessary measures.',
      line6: '',
      line7: '',
      line8: '',
      line9: '',
      line10: '',
      line11: '',
      line12: '',
    },
    s4: {
      title: '4. Ethical Standards for Reviewers',
      line1:
        '4.1. Contribution to Editorial Decisions: Reviewers provide valuable feedback that aids editorial decisions and helps authors improve their articles.',
      line2: '4.2. Timeliness: Reviews must be submitted within the agreed timeframe.',
      line3: '4.3. Confidentiality: Articles under review must be treated as confidential documents.',
      line4:
        '4.4. Objectivity: Reviews should be objective and based on scientific merit, with substantiated arguments and references.',
      line5:
        '4.5. Source Acknowledgment: Reviewers should identify relevant sources not cited by the authors and report any substantial similarities to other published work.',
      line6:
        '4.6. Conflict of Interest: Reviewers must not use unpublished article information for their own research and should decline to review articles where a conflict of interest exists.',
      line7: '',
      line8: '',
      line9: '',
      line10: '',
      line11: '',
      line12: '',
    },
    s5: {
      title: '5. Publication and Malpractice Policies for AdvAES',
      line1:
        '5.1. Publication Standards: Decisions on corrections, retractions, replacements, or removals are made by the editors, with input from reviewers and editorial board members as needed.',
      line2:
        '5.1.1. Retraction: Retractions are considered for articles with significant errors, ethical violations, or fraudulent data. Retracted articles are clearly marked and linked to the retraction notice.',
      line3:
        "5.1.2. Correction: Corrections (errata, corrigenda, addenda) are issued for minor errors that do not invalidate the article's conclusions.",
      line4: '5.1.3. Withdrawal: Withdrawal is considered only for early versions of unpublished articles.',
      line5:
        '5.1.4. Removal: Articles may be removed in rare cases of defamatory content, legal violations, or serious health threats.',
      line6:
        '5.1.5. Replacement: In cases of serious health risks, articles may be retracted and replaced with corrected versions.',
      line7:
        '5.2. Complaint Handling: Complaints regarding journal policies or editorial actions are thoroughly investigated.',
      line8: '',
      line9: '',
      line10: '',
      line11: '',
      line12: '',
    },
    s6: {
      title: '6. Copyright and Open Access',
      line1:
        'Authors retain copyright and grant the journal first publication rights and non-exclusive publishing rights.',
      line2:
        'AdvAES is an open-access journal, with articles freely available under the Creative Commons Attribution-ShareAlike 4.0 International License (CC BY-SA 4.0).',
      line3: '',
      line4: '',
      line5: '',
      line6: '',
      line7: '',
      line8: '',
      line9: '',
      line10: '',
      line11: '',
      line12: '',
    },
    s7: {
      title: '7. Warranties',
      line1: 'Authors warrant that their submissions are original and do not infringe on copyrights.',
      line2: 'Authors are responsible for obtaining permission for third-party material.',
      line3: 'Submissions must not be under consideration or have been published elsewhere.',
      line4: '',
      line5: '',
      line6: '',
      line7: '',
      line8: '',
      line9: '',
      line10: '',
      line11: '',
      line12: '',
    },
    s8: {
      title: '8. Publication Frequency and Scope',
      line1: 'AdvAES is published quarterly, featuring at least 10 articles per issue.',
      line2:
        'The journal focuses on advancements and innovations in applied engineering sciences, including sustainable energy, advanced materials, and digital technologies.',
      line3: '',
      line4: '',
      line5: '',
      line6: '',
      line7: '',
      line8: '',
      line9: '',
      line10: '',
      line11: '',
      line12: '',
    },
  },
  footerText:
    'We are committed to maintaining the highest standards of scientific integrity and quality in all our publications.',
};
